var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDengju(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_30_1251)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 3.8L7.125 7.3L10 3L8.5 1.5L4 3.8ZM14 15H5.875H14ZM7.4375 15V13.6V15Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 15H5.875M7.4375 15V13.6M4 3.8L7.125 7.3L10 3L8.5 1.5L4 3.8Z",
    stroke: "black",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1975 15L15 9.34286L8 4",
    stroke: "black",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 15L3.57143 5L5 6.42857L3.57143 15H0Z",
    fill: "#FFE100"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_30_1251"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDengju);
export default __webpack_public_path__ + "static/media/dengju.2ba6c6b8eedff0dbb50b3e6861cc3658.svg";
export { ForwardRef as ReactComponent };